import { c as _c } from "react/compiler-runtime";
import { TabPanel } from "@website/accommodation-ui/villa-reserve-cancellation-policies/components/tab-panel-cancellation-type/tab-panel";
import { villaReserveCancellationPolicyType } from "@website/accommodation-ui/villa-reserve-cancellation-policies/index.types";
import { useState } from "react";
export const useVillaReserveCancellationPolicies = properties => {
  const $ = _c(13);
  const {
    policies,
    cancellationPlanType
  } = properties;
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  let t0;
  if ($[0] !== cancellationPlanType || $[1] !== policies) {
    const filteredPolicies = policies.filter(_temp);
    let t1;
    if ($[3] !== cancellationPlanType) {
      t1 = p_0 => ({
        title: p_0.title as string,
        panel: <TabPanel cancellationPlanType={cancellationPlanType} cancellationRules={p_0.text} />
      });
      $[3] = cancellationPlanType;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = filteredPolicies.map(t1);
    $[0] = cancellationPlanType;
    $[1] = policies;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const tabs = t0;
  let t1;
  if ($[5] !== tabs) {
    t1 = {
      tabs
    };
    $[5] = tabs;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const policiesData = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsRulesModalOpen(true);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const openRulesModal = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsRulesModalOpen(false);
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const closeRulesModal = t3;
  const t4 = policiesData?.tabs?.[0]?.panel;
  let t5;
  if ($[9] !== isRulesModalOpen || $[10] !== policiesData || $[11] !== t4) {
    t5 = {
      isRulesModalOpen,
      openRulesModal,
      closeRulesModal,
      policiesData,
      defaultTabPanel: t4
    };
    $[9] = isRulesModalOpen;
    $[10] = policiesData;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(p) {
  return Boolean(p.text);
}